import { useEffect } from 'react'
import { useLocation } from 'react-router'

export default function usePageViewTracker () {
  const location = useLocation()

  useEffect(() => {
    window.segment?.page('', 'app_frontend_page')
  }, [location])
}
